module.exports = __webpack_public_path__ + "img/image3.e3673192.png";